var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{staticClass:"pa-0",attrs:{"items":_vm.crumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('Breadcrumb',{attrs:{"item":item}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }